export default {
  id: 'rsrc.CloseSelected',
  name: 'Close Selected (Esc)',
  matches: {
    client: ['rsrc.gallery.RsrcSelectedDialog'],
    objectType: 'rsrc',
    use: '!contextMenu'
  },
  sort: 'zzz',
  handles: () => true,
  appearance: ({
    context
  }) => {
    return {
      name: 'Close Selected (Esc)',
      icon: 'fa fa-fw fa-close'
    };
  },
  perform: async ({
    context
  }) => {
    const {
      clientProps: {
        onClose
      }
    } = context;
    onClose?.();
  }
};